import {useRef,useState,useEffect,useContext,Fragment} from "react"
import ModalContext from "../contexts/ModalContext"
import useApi from "../hooks/useApi"
import useModal from "../hooks/useModal"
import useDialog from "../hooks/useDialog"
import useToast from "../hooks/useToast"
import ModalHeader from "../components/ModalHeader"
import ModalContent from "../components/ModalContent"
import ModalTitle from "../components/ModalTitle"
import ButtonBack from "../commons/ButtonBack"
import ButtonPrimary from "../commons/ButtonPrimary"
import Selector from "../commons/Selector"

const gatewayOptions=[
    {label:"PayZen",value:"payzen"},
    {label:"Mobbex",value:"mobbex"}
]

export default function ShopGatewayEdit(){

    const [modalContext]=useContext(ModalContext)
    const {changeModal,modalReady}=useModal()
    const {changeDialog}=useDialog()
    const {changeToast}=useToast()
    const requestApi=useApi()
    const pointId=modalContext.reference["point"]
    const gatewayInput=useRef()
    const [gatewayVal,setGatewayVal]=useState()

    useEffect(()=>{
        modalReady(0)
        requestApi("shops/point_gateway",{
                point_id:pointId
            })
            .then(data=>{
                gatewayOptions.forEach(function(item){
                    if(item.value==data.data.gateway){
                        gatewayInput.current.setValue({label:item.label,value:item.value})
                    }
                })
                modalReady(1)
            })
    },[])

    const saveData=()=>{
        requestApi("shops/point_gateway_save",{
                point_id:pointId,
                gateway_name:gatewayInput.current.getValue()[0]?gatewayInput.current.getValue()[0].value:""
            })
            .then(data=>{
                if(data.status=="success"){
                    changeModal("shop-point","",pointId)
                    changeToast("saved","")
                }else{
                    changeDialog("generic_error","","")
                }
            })
    }

    return(
        <Fragment>
            <ModalHeader>
                <ButtonBack clickEvent={()=>{changeModal("shop-point","",pointId)}} />
                <ButtonPrimary label="Guardar" clickEvent={saveData} />
            </ModalHeader>
            <ModalContent>
                <div className="modal-form">
                    <ModalTitle title="Proveedor de pagos" />
                    <Selector ref={gatewayInput} val={gatewayVal} setVal={setGatewayVal} placeholder="Proveedor" searchable={0} options={gatewayOptions} />
                </div>
            </ModalContent>
        </Fragment>
    )

}
